import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Focussable} from '../../../../components/common/focussable';
import {UntypedFormGroup} from '@angular/forms';
import {IonInput} from '@ionic/angular';

@Component({
  selector: 'app-input-textarea',
  templateUrl: './input-textarea.component.html',
  styles: [
  ]
})
export class InputTextareaComponent implements OnInit, Focussable {

  @Input() maxLength: number = undefined;
  @Input() rows = 3;
  @Input() parentFormGroup: UntypedFormGroup;
  @Input() parentFormControlName: string;
  @Input() placeHolder = '';
  @ViewChild('input') inputRef: IonInput;
  @Output() keyPressedEvent = new EventEmitter<string>();
  @Output() focussedEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() changedEvent = new EventEmitter<void>();

  constructor() {
  }


  ngOnInit() {
  }

  onKeyPressed(event) {
    this.keyPressedEvent?.emit(event);
    this.changed();
  }

  focus() {
    this.inputRef?.setFocus();
  }

  focussed() {
    this.focussedEvent.emit();
  }

  changed() {
    this.changedEvent.emit();
  }
}
